import type { IPathBaseParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import type {
  IFileBasedExamAttemptResponse,
  IFileBasedExamAttemptGetAllParams,
} from "@api/courses/exams/fileBased/attempts/types";
import { createGetAllApi } from "@api/util/createGetAllApi";
import type { ICourseResponse } from "@api/courses/types";

const getAllApis = createGetAllApi<
  IApiResponse<
    IPagination<IFileBasedExamAttemptResponse, { course: ICourseResponse }>
  >,
  IPathBaseParam,
  IPaginationParams & IFileBasedExamAttemptGetAllParams
>("courses.exams.fileBased.attempt.latest");

export const latest = {
  ...getAllApis,
};
